<i18n lang="yaml" locale="en">
  add field: Add field
  download data: Download data
  new field: New field
  send: Submit
  field input: Input
  field checkbox: Checkbox
  field text: Text
  field submit: Submit
  input text: Text
</i18n>

<i18n lang="yaml" locale="de">
  add field: Feld hinzufügen
  download data: Daten herunterladen
  new field: Neues Feld
  send: Absenden
  field input: Eingabe
  field checkbox: Checkbox
  field text: Text
  field submit: Absenden
  input text: Text
</i18n>

<template>
  <section class="form-editor">
    <draggable
      class="fields"
      :options="{ handle: '.field' }"
      @change="save"
      :list="formObject.fields"
    >
      <div
        class="field"
        v-for="field in formObject.fields"
        :key="field.id"
        :class="field.type"
      >
        <span class="field-label">
          {{ field.type === 'submit' ? field.buttonText : field.label }}
        </span>
        <delete
          class="icon"
          size="xs"
          color="danger"
          @click="deleteField(field.id)"
        />
        <settings
          class="icon"
          size="xs"
          @click="showFieldEditor(field.id)"
        />
      </div>
    </draggable>
    <field-editor
      @close="fieldEditorIsActive = false"
      :value="fieldEditorValue"
      @input="updateField($event)"
      v-if="fieldEditorIsActive"
    />
    <div class="buttons">
      <tw-button
        icon="addCircle"
        color="main"
        @click="addField()"
      >
        {{ $t('add field') }}
      </tw-button>
      <a :href="downloadURL">
        <tw-button
          class="download-button"
          icon="save"
          color="main"
        >{{ $t('download data') }}</tw-button>
      </a>
    </div>
  </section>
</template>

<script>
import TwButton from '@/components/ui/TwButton'
import FormFieldEditor from '@/components/editor/FormFieldEditor'
import Delete from '@/components/icons/Delete'
import Settings from '@/components/icons/Settings'
import { randomId } from '@/utils'
import draggable from '@/components/editor/draggable'

export default {
  fieldOptions: {
    input: 'field input',
    twCheckbox: 'field checkbox',
    staticText: 'field text',
    submit: 'field submit'
  },
  inputOptions: {
    text: 'field text'
  },
  components: {
    fieldEditor: FormFieldEditor,
    TwButton,
    Delete,
    Settings,
    draggable
  },
  data () {
    return {
      formObject: this.value,
      fieldIdList: [],
      fieldEditorIsActive: false,
      fieldEditorValue: {}
    }
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    downloadURL () {
      return this.$root.$route.path + '/data?form=' + this.$store.getters.name
    }
  },
  methods: {
    t (...args) {
      return this.$t(...args)
    },
    updateField (field) {
      // TODO: check that there is only one submit button and snotify a warning if there is another one, don't add it
      const { index } = this.getFieldPath(field.id)
      if (index > -1) {
        this.formObject.fields[index] = field
      }
      this.save()
    },
    addField () {
      const id = randomId(this.fieldIdList)
      this.formObject.fields.push({
        id: id,
        model: id,
        label: this.$t('new field'), // TODO: set the default values from somewhere more intelligent
        type: 'input',
        inputType: 'text',
        buttonText: this.$t('send')
      })
      this.fieldIdList.push(id)
      this.save()
    },
    deleteField (id) {
      const { index } = this.getFieldPath(id)
      if (index > -1) {
        this.formObject.fields.splice(index, 1)
      }
      this.save()
    },
    showFieldEditor (id) {
      const { index } = this.getFieldPath(id)
      if (index > -1) {
        this.fieldEditorValue = this.formObject.fields[index]
      }
      this.fieldEditorIsActive = true
    },
    getFieldPath (id) {
      const path = { index: undefined }
      path.index = this.formObject.fields.findIndex(f => f.id === id)
      return path
    },
    save (evt) {
      this.$emit('input', this.formObject)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.form-editor {
  width: 100%;
}

.fields {
  margin-top: 20px;
  margin-bottom: 20px;

  &:first-child {
    margin-top: 0px;
  }

  .field {
    display: flex;
    cursor: move;
    width: 100%;
    background-color: transparent;
    align-items: center;
    padding: 10px;
    border: 1px solid rgba($color: #fff, $alpha: 0.25);
    margin-top: 10px;
    border-radius: 5px;

    &.staticText {
      border-color: transparent;
      text-transform: uppercase;
      font-weight: 300;
      font-size: 16px;
    }

    &.submit {
      color: $color-main;
      text-transform: uppercase;
    }

    .field-label {
      margin-right: 20px;
      width: -webkit-fill-available;
    }

    .icon {
      margin-left: 8px;
    }
  }
}

.buttons {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
</style>
